import { gsap, ScrollTrigger } from '../lib/gsap';

const initLoadIn = (elements) => {
    // set options
    const durationTime = 0.85;
    const easing = 'power2';
    const startPos = 'top 85%';

    // Set inital state to avoid flash of content
    gsap.set(elements, {
        opacity: 0
    });

    ScrollTrigger.batch(elements, {
        invalidateOnRefresh: true,
        start: startPos,
        onEnter: (batch) => gsap.to(
            batch, {
                duration: durationTime,
                opacity: 1,
                stagger: 0.025,
                ease: easing
            }
        )
    });
};

export { initLoadIn as default };
